import RequestWatcher from '../request-watcher';
import { PollingIntervals } from '../constants';

let ssoWatcher;

export function watchSso(email, timeout) {
    unwatchSso();
    const urlFunction = () => {
        return `/api/Sso/logInfo?emailAddress=${email}`;
    };
    ssoWatcher = new RequestWatcher({ pollTimeout: timeout || PollingIntervals.aggressive }).watch(
        urlFunction
    );
    return ssoWatcher;
}

export function unwatchSso() {
    if (ssoWatcher) ssoWatcher.stop();
}